.certifications-section {
  margin-top: clamp(48px, 5vw, 72px);
  padding-top: clamp(24px, 2.5vw, 32px);
  border-top: 1px solid #f1f1f1;
}

.certifications-title {
  margin: 0;
  color: #160004;
  font-size: clamp(22px, 2.3vw, 30px);
  font-family: Red Rose-SemiBold;
  text-transform: uppercase;
  line-height: 1.1;
}

.certifications-grid {
  margin-top: 28px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}

.certification-card {
  display: flex;
  align-items: center;
  gap: 28px;
  min-height: 160px;
  padding: 28px 30px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 2px;
}

.certification-card__logo-wrap {
  width: 135px;
  flex: 0 0 135px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.certification-card__logo {
  display: block;
  width: 105px;
  height: auto;
  object-fit: contain;
}

.certification-card__logo--carb {
  width: 135px;
}

.certification-card__body {
  min-width: 0;
  flex: 1;
}

.certification-card__title {
  margin: 0;
  color: #160004;
  font-size: 15px;
  font-family: inherit;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  line-height: 1.35;
}

.certification-card__description {
  margin: 10px 0 0;
  color: rgba(22, 0, 4, 0.65);
  font-size: 14px;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.55;
}

@media (max-width: 767px) {
  .certifications-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .certification-card {
    min-height: auto;
    padding: 24px;
    gap: 20px;
  }

  .certification-card__logo-wrap {
    width: 105px;
    flex-basis: 105px;
  }

  .certification-card__logo {
    width: 85px;
  }

  .certification-card__logo--carb {
    width: 105px;
  }
}
